import React from 'react'

import App from './App'
import { Router } from './core/router/router'
import { useTheme } from './core/hooks/use-theme'
import { useUsuarioLogado } from './core/hooks/use-usuario-logado'
import { Loading } from './core/components/loading'

export const PrivateApp = ({ manifest }) => {
  useTheme()
  const { usuarioLogado } = useUsuarioLogado()

  if (!usuarioLogado) {
    return <Loading />
  }

  return (
    <App
      currentUser={usuarioLogado}
      manifest={manifest}
      router={<Router />}
      header
    />
  )
}
